const $ = jQuery;

export default () => {
  //
  $('body').addClass('loaded');

  // Nav Click
  const $nav = $('.header .nav');
  const $burger = $('#hamburger');

  $burger.on('click', function() {
    $(this).toggleClass('change'), $nav.toggleClass('change');
  });

  // Nav Follow Click
  const $navfollow = $('.follow-head');
  const $burgerfollow = $('.follow-btn');

  $burgerfollow.on('click', function() {
    $(this).toggleClass('change'), $navfollow.toggleClass('change');
  });

  // Search Click
  const $searchover = $('.search-overlay');
  const $searchcon = $('.search-icon');
  const $searchclose = $('.search-close');

  $searchcon.on('click', function() {
    $searchover.addClass('change');
  });
  $searchclose.on('click', function() {
    $searchover.removeClass('change');
  });

  // Search Click
  // const $followover = $('.follow-head');
  // const $followcon = $('.follow-btn');
  //
  // $followcon.on('click', function() {
  //   $followover.toggleClass('change');
  // });
};
